export default __webpack_public_path__ + "static/media/bg-judicial-produto.b24c2867.webp";